export const menuPlacement = {
    AUTO: 'auto',
    BOTTOM: 'bottom',
    TOP: 'top',
};
